class AnnouncementBar extends HTMLElement {
  constructor () {
    super()

    if (this.slides.length <= 1) return

    this.animateSlides()
  }

  animateSlides () {
    this.activeSlide = 0
    const transitionInterval = this.dataset.transitionInterval * 1000

    setInterval(() => {
      const isLastSlide = this.activeSlide === this.slides.length - 1
      this.activeSlide = isLastSlide ? 0 : this.activeSlide += 1

      this.slides.forEach((slide, i) => {
        slide.dataset.activeSlide = i === this.activeSlide ? 'true' : 'false'
      })
    }, transitionInterval)
  }

  get slides () {
    return this.querySelectorAll('[data-announcement-bar-el="slide"]')
  }

  get activeSlide () {
    return this._activeSlide
  }

  set activeSlide (val) {
    this._activeSlide = val
  }
}
customElements.define('announcement-bar', AnnouncementBar)
